/**
 * KAN-826: a file column picker of the upload form. A select of the real
 * headers (empty choice first) when they are known, otherwise a free-text
 * input for the column name.
 */
import { Input } from '@/components/ui/input';
import { NativeSelect } from '@/components/ui/native-select';
import { SKIP_COLUMN_LABEL } from './ColumnMappingFields';

interface UploadColumnPickerProps {
  id: string;
  selectTestId: string;
  inputTestId: string;
  value: string;
  onChange: (column: string) => void;
  headers: string[];
  /** Label of the empty choice of the select. */
  emptyLabel?: string;
  ariaLabel?: string;
}

export function UploadColumnPicker({
  id,
  selectTestId,
  inputTestId,
  value,
  onChange,
  headers,
  emptyLabel = SKIP_COLUMN_LABEL,
  ariaLabel,
}: UploadColumnPickerProps): JSX.Element {
  if (headers.length === 0) {
    return (
      <Input
        id={id}
        data-testid={inputTestId}
        aria-label={ariaLabel}
        placeholder="Название колонки в файле"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }
  return (
    <NativeSelect
      id={id}
      data-testid={selectTestId}
      aria-label={ariaLabel}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      options={[
        { value: '', label: emptyLabel },
        ...headers.map((h) => ({ value: h, label: h })),
      ]}
    />
  );
}
